import React from "react";

import { useScope } from "~/tools/impulse";

import { HighlightTimestampCursor, useTimestampCursorState } from "../../TimestampCursor";

import { TimelineMarker } from "./TimelineMarker";

export const TimelineMarkers: React.FC = () => {
	const scope = useScope();
	const timestampCursorState = useTimestampCursorState();
	const isTimestampCursorHotkeyPressed = timestampCursorState.isHotkeyPressed(scope);

	return (
		<div className={isTimestampCursorHotkeyPressed ? "pointer-events-auto" : "pointer-events-none"}>
			{timestampCursorState.getAllMarkers(scope).map(({ timestamp, isHighlighted }) => (
				<TimelineMarker key={timestamp} theme={isHighlighted ? "red" : "purple"} timestamp={timestamp}>
					{/* the negative margin creates an invisible clickable marker's area */}
					<HighlightTimestampCursor className="absolute inset-0 m-[-3px]" timestamp={timestamp} />
				</TimelineMarker>
			))}
		</div>
	);
};
